<div class="switcher">
    <p-selectButton [options]="layoutOptions" [(ngModel)]="selectedLayout"  optionLabel="label" (ngModelChange)="setLayout($event.value)"></p-selectButton>
</div>
